import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React, { Component, useState } from 'react';

import { Avatar, Stack } from '@mui/material';
import { IDiscussionResponse } from 'redux/reducers/user/dashboard/tms-discussion';

const CommentReply = ({ reply }: { reply: IDiscussionResponse }) => {
  return (
    <Box m={2}>
      <Stack
        direction="row"
        justifyContent="flex-start"
        p={1}
        sx={{
          backgroundColor: 'white',
          height: 1
        }}
        spacing={1}
      >
        <Avatar alt={reply.user.email} src={reply.user.profile ?? ''} />
        <Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <Typography
              sx={{
                fontSize: '15px'
              }}
            >
              {reply.user.email}
            </Typography>
            <Typography
              sx={{
                fontSize: '10px',
                marginLeft: 2
              }}
            >
              {reply.edited}
            </Typography>
          </Box>
          <Box>
            <Typography
              sx={{
                fontSize: '15px'
              }}
            >
              {reply.content}
            </Typography>
          </Box>
        </Box>
      </Stack>
    </Box>
  );
};

export default CommentReply;
